import { config } from "../config";

export const trimText = (message) => (message ? message.trim() : "");

const isValidText = ({ text, minLength = 0, maxLength, trimContent = false }) => {
  let auxText = `${text}`;
  if (trimContent) {
    auxText = trimText(text);
  }

  if (!auxText) {
    return false;
  }

  if (auxText.length < minLength || auxText.length > maxLength) {
    return false;
  }

  return true;
};

const isMinLengthText = ({ text, minLength = 0, trimContent = false }) => {
  let auxText = `${text}`;
  if (trimContent) {
    auxText = trimText(text);
  }

  if (!auxText) {
    return true;
  }

  if (auxText.length < minLength) {
    return true;
  }

  return false;
};

const isMaxLengthText = ({ text, maxLength, trimContent = false }) => {
  let auxText = `${text}`;
  if (trimContent) {
    auxText = trimText(text);
  }

  if (!auxText) {
    return false;
  }

  if (auxText.length >= maxLength) {
    return true;
  }

  return false;
};

export const isValidLiveSessionTitle = (title, trimContent = false) =>
  isValidText({
    text: title,
    minLength: config.MIN_LIVE_SESSION_TITLE_LENGTH,
    maxLength: config.MAX_LIVE_SESSION_TITLE_LENGTH,
    trimContent,
  });

export const isMinLengthLiveSessionTitle = (title, trimContent = false) =>
  isMinLengthText({
    text: title,
    minLength: config.MIN_LIVE_SESSION_TITLE_LENGTH,
    trimContent,
  });

export const isMaxLengthLiveSessionTitle = (title, trimContent = false) =>
  isMaxLengthText({
    text: title,
    maxLength: config.MAX_LIVE_SESSION_TITLE_LENGTH,
    trimContent,
  });

export const isValidLiveSessionDescription = (description, trimContent = false) =>
  isValidText({
    text: description,
    minLength: config.MIN_LIVE_SESSION_DESCRIPTION_LENGTH,
    maxLength: config.MAX_LIVE_SESSION_DESCRIPTION_LENGTH,
    trimContent,
  });

export const isMinLengthLiveSessionDescription = (description, trimContent = false) =>
  isMinLengthText({
    text: description,
    minLength: config.MIN_LIVE_SESSION_DESCRIPTION_LENGTH,
    trimContent,
  });

export const isMaxLengthLiveSessionDescription = (description, trimContent = false) =>
  isMaxLengthText({
    text: description,
    maxLength: config.MAX_LIVE_SESSION_DESCRIPTION_LENGTH,
    trimContent,
  });

export const isValidChatMessage = (message, trimContent = false) =>
  isValidText({
    text: message,
    minLength: config.MIN_LIVE_CHAT_MESSAGE_LENGTH,
    maxLength: config.MAX_LIVE_CHAT_MESSAGE_LENGTH,
    trimContent,
  });
